import { Grid, Table, TableBody, TableCell, Typography, useTheme } from "@mui/material";
import Loader from "../../ui/Loader";
import { ErrorProps } from "./propType";

export const TableLoader = () => {
  return (
    <TableCell colSpan={20}>
      <Grid display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <Loader />
      </Grid>
    </TableCell>
  );
};

export const TableDataLoader=()=>{
  return (
    <Table>
      <TableBody >
        <TableLoader/>
      </TableBody>
    </Table>
  )
}

export const TableErrorMessage = (props: ErrorProps) => {
  const { isError, isNoContent=true } = props;
  const theme = useTheme();
  return (
    <TableCell colSpan={20}>
      <Grid width={"100%"} display={"flex"} justifyContent={"center"}>
        <Typography
          fontFamily={theme?.font?.fontFamily.primary}
          sx={{ color: theme.color?.tableGrey }}
        >
          {isError && "Something went wrong, please try again later."}
          {isNoContent && "No data to display"}
        </Typography>
      </Grid>
    </TableCell>
  );
};
